import { Badge, Button, Card, Col, Row, Table, Typography } from "antd";
import dayjs from "dayjs";
import { get, isNumber } from "lodash";
import React from "react";
import { DEFAULT_VALUE } from "../../../app/_redux/constants";
import { PAGINATION } from "../../_redux/constant";

const { Text } = Typography;
function Cameras({
  total_elements,
  loading,
  dataSource,
  params,
  onChangeParam
}) {
  const CARD_STYLE = {
    borderRadius: "0.42rem",
    boxShadow: "0px 0px 30px 0px rgba(82, 63, 105, 0.05)"
  };
  const CARD_BODY_STYLE = {
    padding: "10px"
  };
  const CARD_HEAD_STYLE = {
    padding: "8px",
    borderBottom: "none"
  };
  const SNoStyle = {
    color: "#14a05b",
    fontWeight: "bold",
    display: "inline-block",
    textAlign: "center"
  };

  const columns = [
    {
      dataIndex: "stt",
      title: "STT",
      align: "center"
    },
    {
      dataIndex: "station_name",
      title: "Kho",
      key: "station_name",
      align: "left",
      render: (station_name, record) => {
        return (
          <Text>
            <span style={SNoStyle}>{get(record, "station_id", "-")}</span>
            {station_name ? " | " + station_name : " | " + DEFAULT_VALUE}
          </Text>
        );
      }
    },
    {
      dataIndex: "gate_name",
      key: "gate_name",
      title: "Tên cổng",
      align: "left",
      render: value => value || DEFAULT_VALUE
    },
    {
      title: "Camera",
      children: [
        {
          dataIndex: "name",
          key: "name",
          title: "Tên camera",
          align: "left",
          render: value => value || DEFAULT_VALUE
        },
        {
          title: "SN camera",
          dataIndex: "sn",
          key: "sn",
          align: "center",
          render: value => value || DEFAULT_VALUE
        },
        {
          dataIndex: "ip",
          key: "ip",
          title: "IP camera",
          align: "center",
          render: ip => ip || DEFAULT_VALUE
        },
        {
          dataIndex: "port",
          key: "port",
          title: "Port",
          align: "center",
          render: value => value || DEFAULT_VALUE
        },

        {
          title: "Trạng thái",
          dataIndex: "status",
          align: "center",
          render: value => {
            if (isNumber(value) && value >= 0) {
              return (
                <Badge
                  color={value === 0 ? "red" : "green"}
                  text={value === 0 ? "Offline" : "Online"}
                />
              );
            }
            return;
          }
        },
        {
          title: "Lần cuối online",
          dataIndex: "latest_online",
          align: "center",
          render: value => {
            return value ? dayjs(value).format("DD/MM/YYYY HH:mm:ss") : "";
          }
        }
      ]
    },
    {
      title: "PC",
      children: [
        {
          dataIndex: "gbarrier_ip",
          key: "gbarrier_ip",
          title: "IP server",
          align: "center",
          render: ip => ip || DEFAULT_VALUE
        },
        {
          dataIndex: "gbarrier_port",
          key: "gbarrier_port",
          title: "Port server",
          align: "center",
          render: value => value || DEFAULT_VALUE
        },
        {
          dataIndex: "pc_mac",
          key: "pc_mac",
          title: "MAC server",
          align: "center",
          render: value => value || DEFAULT_VALUE
        },
        {
          title: "Trạng thái",
          dataIndex: "pc_status",
          align: "center",
          render: value => {
            if (isNumber(value) && value >= 0) {
              return (
                <Badge
                  color={value === 0 ? "red" : "green"}
                  text={value === 0 ? "Offline" : "Online"}
                />
              );
            }
            return;
          }
        },
        {
          title: "Lần cuối online",
          dataIndex: "pc_updated_date",
          align: "center",
          render: value => {
            return value ? dayjs(value).format("DD/MM/YYYY HH:mm:ss") : "";
          }
        }
      ]
    }
  ];

  const renderCardExtra = () => {
    return (
      <div className="d-flex aligns-items-center my-2">
        <Button
          onClick={() => {
            onChangeParam({
              page: params.page,
              size: params.size
            });
          }}
          type="dashed"
        >
          Làm mới
        </Button>
      </div>
    );
  };
  return (
    <Card
      className="log__container"
      size="small"
      style={CARD_STYLE}
      body={{
        body: CARD_BODY_STYLE,
        head: CARD_HEAD_STYLE
      }}
      title={
        <Row align="middle" gutter={[8]} justify="start">
          <Col>
            <Text>
              Tổng số camera:{" "}
              <Text className="text-dark">{total_elements}</Text>
            </Text>
          </Col>
        </Row>
      }
      extra={renderCardExtra()}
    >
      <Table
        loading={loading}
        rowKey="id"
        size="large"
        bordered
        columns={columns}
        dataSource={dataSource}
        pagination={{
          pageSize: params.size,
          current: params.page,
          defaultPageSize: PAGINATION.camera.page,
          total: total_elements,
          showSizeChanger: true,
          onChange: (page, pageSize) => {
            onChangeParam({
              page: page,
              size: pageSize
            });
          }
        }}
        scroll={{ x: 1366 }}
      />
    </Card>
  );
}

export default React.memo(Cameras);
